import React from "react"
import Form from "../../form"
import { createMarkup } from "../../../../utils/markup-creator"
import BackgroundImageDynamic from "../components/background-image-dynamic"
import { SectionType } from "../../../types"
import { url } from "inspector"

type SectionProps = {
  section: SectionType
  index: any
  [key: string]: any
}

const SplitImageFullSection = ({ section, index, ...props }: SectionProps) => {

  return (
    <div className={`relative w-full py-20 pb-0 md:py-40 lg:py-60 bg-cover bg-top bg-no-repeat md:bg-center lg:bg-contain lg:bg-right`} style={{ boxShadow: `0px 10px 30px rgba(0,0,0,0.1)`, backgroundImage: `url(${section.advanced?.backgroundImageLg})`, backgroundSize: `contain`}}>
      <div className="container">
        <div className={`max-w-lg px-4 sm:px-6 xl:px-0 flex justify-${section.advanced?.position || `end`}`}>
          <Form form={section.form} />
        </div>
      </div>
    </div>
  )
}

export default SplitImageFullSection
